import type { SVGProps } from 'react';

const SvgTimeLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <rect x={3} y={3} width={18} height={18} rx={9} stroke='currentColor' />
    <path
      d='M12 7.5V11.75C12 11.9074 12.0741 12.0556 12.2 12.15L15.6 14.7'
      stroke='currentColor'
      strokeLinecap='round'
    />
  </svg>
);
export default SvgTimeLt;
